import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Patient Pages
import PatientAuthPage from '../pages/patient/PatientAuthPage';
import PatientDashBoard from '../pages/patient/PatientDashboard';
import PatientProfilePage from '../pages/patient/PatientProfilePage';
import PatientSurvey from '../pages/patient/PatientSurveyPage';
import PatientBookingHistoryPage from '../pages/patient/PatientBookingHistory';
import PatientBookingSummaryPage from '../pages/patient/PatientBookingSummary';
import PatientMessagesPage from '../pages/patient/PatientMessagesPage';

// Doctor Pages
import DoctorDetailPage from '../pages/doctor/DoctorDetailPage';
import DoctorMessagesPage from '../pages/doctor/DoctorMessagesPage';
import DoctorPatientsPage from '../pages/doctor/DoctorPatientsPage';
import DoctorAppointmentsPage from '../pages/doctor/DoctorAppoinmentsPage';
import DoctorStatisticsPage from '../pages/doctor/DoctorStatisticsPage';
import DoctorDashboad from '../pages/doctor/DoctorDashboard';
import DoctorFeedbackPage from '../pages/doctor/DoctorFeedbackPage';
import DoctorSettingsPage from '../pages/doctor/DoctorSettingsPage';
import DoctorCalendarPage from '../pages/doctor/DoctorCalendarPage';
import DoctorBillingPage from '../pages/doctor/DoctorBillingPage';

// Admin Pages
import AdminAuthPage from '../pages/admin/AdminAuthPage';
import AdminDashboard from '../pages/admin/AdminDashboard';
import AdminSurveyPage from '../pages/admin/AdminSurveyPage';
import AdminDetailsUserPage from '../pages/admin/AdminDetailsUserPage';
import AdminListUsersPage from '../pages/admin/AdminListUsersPage';
import AdminCreateDoctorPage from '../pages/admin/AdminCreateDoctor';
import AdminDoctorListPage from '../pages/admin/AdminDoctorListPage';
import AdminDoctorDetailPage from '../pages/admin/AdminDoctorDetailPage';
import AdminAppointmentsPage from '../pages/admin/AdminAppoinmentsPage';
import AdminBillingPage from '../pages/admin/AdminBillingPage';

// Common Pages
import PaymentSuccessPage from '../pages/payment/PaymentSuccessPage';
import PaymentCancelPage from '../pages/payment/PaymentCancelPage';
import NotFoundPage from '../pages/NotFoundPage';
import PasswordResetPage from '../pages/PasswordResetPage';
import LogoutPage from '../pages/LogoutPage';

// Protected Routes
import { 
  ProtectedAdminRoute, 
  ProtectedDoctorRoute, 
  ProtectedPatientRoute,
  ProtectedMultiRoleRoute 
} from '../components/common/ProtectedRoute';
import AdminFeedbackPage from '../pages/admin/AdminFeedbackPage';
import AdminPaymentsPage from '../pages/admin/AdminPaymentsPage';

const AppRoutes = () => {
  return (
    <Routes>
      
      {/* Rotte pubbliche */}
      <Route path="/register" element={<Navigate to="/?tag=00" replace />} />
      <Route path="/logout" element={<LogoutPage />} />
      <Route path="/patient/login" element={<PatientAuthPage />} />
      <Route path="/password/reset" element={<PasswordResetPage />} />
      <Route path="/" element={<PatientAuthPage />} />

      {/* Patient Routes - PROTETTE */}
      <Route path="/patient/survey" element={
        <ProtectedPatientRoute>
          <PatientSurvey />
        </ProtectedPatientRoute>
      } />
      
      <Route path="/patient/dashboard" element={
        <ProtectedPatientRoute>
          <PatientDashBoard />
        </ProtectedPatientRoute>
      } />
      
      <Route path="/patient/appointments" element={
        <ProtectedPatientRoute>
          <PatientBookingHistoryPage />
        </ProtectedPatientRoute>
      } />
      
      <Route path="/patient/profile" element={
        <ProtectedPatientRoute>
          <PatientProfilePage />
        </ProtectedPatientRoute>
      } />
      
      <Route path="/patient/messages" element={
        <ProtectedPatientRoute>
          <PatientMessagesPage />
        </ProtectedPatientRoute>
      } />
      
      <Route path="/patient/messagedetails/:id" element={
        <ProtectedPatientRoute>
          <PatientMessagesPage />
        </ProtectedPatientRoute>
      } />
      
      <Route path="/patient/bookingsummary" element={
        <ProtectedPatientRoute>
          <PatientBookingSummaryPage />
        </ProtectedPatientRoute>
      } />
      
      <Route path="/payment/success" element={
        <ProtectedPatientRoute>
          <PaymentSuccessPage />
        </ProtectedPatientRoute>
      } />
      
      <Route path="/payment/cancel" element={
        <ProtectedPatientRoute>
          <PaymentCancelPage />
        </ProtectedPatientRoute>
      } />

      {/* Doctor Detail - Accessibile a pazienti e dottori */}
      <Route path="/doctor/:id" element={
        <ProtectedMultiRoleRoute allowedRoles={['patient', 'therapist']}>
          <DoctorDetailPage />
        </ProtectedMultiRoleRoute>
      } />

      {/* Doctor Routes - PROTETTE */}
      <Route path="/doctor/dashboard" element={
        <ProtectedDoctorRoute>
          <DoctorDashboad />
        </ProtectedDoctorRoute>
      } />
      
      <Route path="/doctor/feedback" element={
        <ProtectedDoctorRoute>
          <DoctorFeedbackPage />
        </ProtectedDoctorRoute>
      } />
      
      <Route path="/doctor/settings" element={
        <ProtectedDoctorRoute>
          <DoctorSettingsPage />
        </ProtectedDoctorRoute>
      } />
      
      <Route path="/doctor/stats" element={
        <ProtectedDoctorRoute>
          <DoctorStatisticsPage />
        </ProtectedDoctorRoute>
      } />
      
      <Route path="/doctor/messages" element={
        <ProtectedDoctorRoute>
          <DoctorMessagesPage />
        </ProtectedDoctorRoute>
      } />
      
      <Route path="/doctor/messagedetails/:id" element={
        <ProtectedDoctorRoute>
          <DoctorMessagesPage />
        </ProtectedDoctorRoute>
      } />
      
      <Route path="/doctor/appointments" element={
        <ProtectedDoctorRoute>
          <DoctorAppointmentsPage />
        </ProtectedDoctorRoute>
      } />
      
      <Route path="/doctor/patient" element={
        <ProtectedDoctorRoute>
          <DoctorPatientsPage />
        </ProtectedDoctorRoute>
      } />
      
      <Route path="/doctor/calendar" element={
        <ProtectedDoctorRoute>
          <DoctorCalendarPage />
        </ProtectedDoctorRoute>
      } />
      
      <Route path="/doctor/billing" element={
        <ProtectedDoctorRoute>
          <DoctorBillingPage />
        </ProtectedDoctorRoute>
      } />

      {/* Admin Routes - TUTTE PROTETTE */}
      <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
      <Route path="/admin/login" element={<AdminAuthPage />} />
      
      <Route path="/admin/dashboard" element={
        <ProtectedAdminRoute>
          <AdminDashboard />
        </ProtectedAdminRoute>
      } />
      
      <Route path="/admin/survey/questions" element={
        <ProtectedAdminRoute>
          <AdminSurveyPage />
        </ProtectedAdminRoute>
      } />
      
      <Route path="/admin/survey/questions/:id" element={
        <ProtectedAdminRoute>
          <AdminSurveyPage />
        </ProtectedAdminRoute>
      } />
      
      <Route path="/admin/doctors" element={
        <ProtectedAdminRoute>
          <AdminDoctorListPage />
        </ProtectedAdminRoute>
      } />
      
      <Route path="/admin/appointments" element={
        <ProtectedAdminRoute>
          <AdminAppointmentsPage />
        </ProtectedAdminRoute>
      } />
      
      <Route path="/admin/doctors/:doctorId" element={
        <ProtectedAdminRoute>
          <AdminDoctorDetailPage />
        </ProtectedAdminRoute>
      } />
      
      <Route path="/admin/doctors/create" element={
        <ProtectedAdminRoute>
          <AdminCreateDoctorPage />
        </ProtectedAdminRoute>
      } />
      
      <Route path="/admin/:userType" element={
        <ProtectedAdminRoute>
          <AdminListUsersPage />
        </ProtectedAdminRoute>
      } />
      
      <Route path="/admin/:userType/:userId" element={
        <ProtectedAdminRoute>
          <AdminDetailsUserPage />
        </ProtectedAdminRoute>
      } />
      
      <Route path="/admin/feedbacks" element={
        <ProtectedAdminRoute>
          <AdminFeedbackPage />
        </ProtectedAdminRoute>
      } />
     
      <Route path="/admin/billing" element={
        <ProtectedAdminRoute>
          <AdminBillingPage />
        </ProtectedAdminRoute>
      } />

      <Route path="/admin/payments" element={
      <ProtectedAdminRoute>
        <AdminPaymentsPage />
      </ProtectedAdminRoute>
    } />


      {/* 404 route */}
      <Route path="*" element={<NotFoundPage />} />

    </Routes>
  );
};

export default AppRoutes;